/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Lines beginning with > are ignored, and whitespace and numbers are removed automatically, so you can paste straight from a FASTA file.`)
};

const es_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Las líneas que comienzan con > se ignoran, y los espacios en blanco y números se eliminan automáticamente, así que puedes pegar directamente desde un archivo FASTA.`)
};

const de_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Zeilen, die mit > beginnen, werden ignoriert, und Leerzeichen sowie Zahlen werden automatisch entfernt, sodass Sie direkt aus einer FASTA-Datei einfügen können.`)
};

const nl_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Regels die beginnen met > worden genegeerd, en witruimte en cijfers worden automatisch verwijderd, zodat je rechtstreeks vanuit een FASTA-bestand kunt plakken.`)
};

const fr_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les lignes commençant par > sont ignorées, et les espaces et chiffres sont supprimés automatiquement, vous pouvez donc coller directement depuis un fichier FASTA.`)
};

const it_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Le righe che iniziano con > vengono ignorate, e spazi bianchi e numeri vengono rimossi automaticamente, quindi puoi incollare direttamente da un file FASTA.`)
};

const pt_br2_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Linhas que começam com > são ignoradas, e espaços e números são removidos automaticamente, para que você possa colar diretamente de um arquivo FASTA.`)
};

const pt_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. As linhas que começam por > são ignoradas, e os espaços em branco e números são removidos automaticamente, pelo que pode colar diretamente de um ficheiro FASTA.`)
};

const ja_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。>で始まる行は無視され、空白と数字は自動的に除去されるので、FASTAファイルから直接貼り付けることができます。`)
};

const zh_revcomp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。以 > 开头的行会被忽略，空白和数字会自动去除，因此你可以直接从 FASTA 文件粘贴。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_faq_a4", locale)
	if (locale === "en") return en_revcomp_faq_a4(inputs)
	if (locale === "es") return es_revcomp_faq_a4(inputs)
	if (locale === "de") return de_revcomp_faq_a4(inputs)
	if (locale === "nl") return nl_revcomp_faq_a4(inputs)
	if (locale === "fr") return fr_revcomp_faq_a4(inputs)
	if (locale === "it") return it_revcomp_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_faq_a4(inputs)
	if (locale === "pt") return pt_revcomp_faq_a4(inputs)
	if (locale === "ja") return ja_revcomp_faq_a4(inputs)
	return zh_revcomp_faq_a4(inputs)
};